import { Button, Group } from "@mantine/core";
import { IconDeviceFloppy, IconSend2, IconClock } from "@tabler/icons-react";

// Action row for the campaign form: Send Now / Schedule (offered only when the
// campaign can still be sent) and the always-present Save Draft submit button.
const CampaignActions = ({
  mode,
  isDirty,
  isSubmitting,
  isBodyEmpty,
  canSendOrSchedule,
  onSendNow,
  onSchedule,
  onSendNowClick,
  onScheduleClick,
}) => {
  return (
    <Group justify="space-between">
      {canSendOrSchedule && onSendNow && (
        <Button
          leftSection={<IconSend2 size={16} />}
          color="green"
          onClick={onSendNowClick}
          disabled={(mode === "create" && !isDirty) || isBodyEmpty}
        >
          Send Now
        </Button>
      )}
      {canSendOrSchedule && onSchedule && (
        <Button
          leftSection={<IconClock size={16} />}
          color="#15AABF"
          onClick={onScheduleClick}
          disabled={(mode === "create" && !isDirty) || isBodyEmpty}
        >
          Schedule
        </Button>
      )}
      <Button
        type="submit"
        leftSection={<IconDeviceFloppy size={16} />}
        loading={isSubmitting}
        disabled={!isDirty}
      >
        Save Draft
      </Button>
    </Group>
  );
};

export default CampaignActions;
